import { render, staticRenderFns } from "./authAudit.vue?vue&type=template&id=4950b58a&scoped=true&"
import script from "./authAudit.vue?vue&type=script&lang=js&"
export * from "./authAudit.vue?vue&type=script&lang=js&"
import style0 from "./authAudit.vue?vue&type=style&index=0&id=4950b58a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4950b58a",
  null
  
)

export default component.exports